import {
  ContextActionCommand,
  ContextActionName,
} from '@wix/public-editor-platform-interfaces';
import { PrivateAPINamespace } from '../PrivateAPINamespace';
import {
  createEditorPlatformPrivateAPIError,
  EditorPlatformPrivateAPIErrorCode,
} from '../../errors';

export class ContextActionsNamespace extends PrivateAPINamespace {
  static readonly namespace = 'contextActions';

  public getContextActions(
    providerIdentifier: string,
    actionNames?: ContextActionName[],
  ): ContextActionCommand[] {
    try {
      const contextActionsService =
        this.ps.platformPackagesBridge?.ContextActionsAPI;

      if (!contextActionsService) {
        throw new Error(
          'ContextActions service is not contributed by the host',
        );
      }

      return contextActionsService.getContextActions({
        providerIdentifier,
        actionNames,
      });
    } catch (error) {
      console.error(error);
      throw createEditorPlatformPrivateAPIError(
        EditorPlatformPrivateAPIErrorCode.GetContextActionsError,
        error instanceof Error
          ? error.message
          : 'get context actions operation failed',
      );
    }
  }
}
